exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-disabled{background-color:#a9a9a9!important}#main-heading{padding:1rem;margin-top:0}#main-heading h2{font-size:1rem}@media screen and (min-width:480px){#main-heading h2{font-size:1.5rem}}@media screen and (min-width:768px){#main-heading h2{font-size:2rem}}.legend-boxes-wrapper{font-size:.8rem}#refresh-anchor{position:relative}#refresh-btn{position:absolute;width:50px;height:50px;right:14px;top:14px;color:#fff;background:#ff9800}#refresh-btn:hover{background:#fff;color:#575757}", ""]);

// exports
